class Config {
  static restUrl(suffix) {
    const res = process.env.REACT_APP_REST_URL + suffix;
    return res;
  }
}

export default Config;
